import {
  changeNum,
  validateEmail,
  validateName,
  validatePhoneNumber,
} from '/util/validation.util';

export function handleNameChange({setName, setNameError}: any) {
  return (candidateName: any) => {
    if (candidateName.length === 1 && candidateName.trim() === '') {
      setName('');
    } else {
      setName(candidateName);
      setNameError(validateName(candidateName));
    }
  };
}
export function handleEmailChange({setEmail, setEmailError}: any) {
  return (candidateEmail: any) => {
    setEmail(candidateEmail);
    setEmailError(!validateEmail(candidateEmail));
  };
}
export function handlePhoneNumberChange({
  setPhoneNumber,
  setPhoneNumberError,
}: any) {
  return (candidateNumber: any) => {
    const cleanedNumber = candidateNumber.replace(/\D/g, '');
    if (validatePhoneNumber(candidateNumber)) {
      setPhoneNumber(
        cleanedNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
      );
      setPhoneNumberError(cleanedNumber.length !== 10);
    }
  };
}

export function getListItems({
  name,
  nameError,
  phoneNumber,
  phoneNumberError,
  email,
  emailError,
  setName,
  setNameError,
  setEmail,
  setPhoneNumber,
  setEmailError,
  setPhoneNumberError,
}: any) {
  const fields = [
    {
      label: 'Name',
      id: 'name',
      onChange: handleNameChange({setName, setNameError}),
      value: name,
      error: nameError,
      errorMessage: 'Please Include a Name for the Candidate.',
    },
    {
      label: 'Phone',
      id: 'phone',
      onChange: handlePhoneNumberChange({setPhoneNumber, setPhoneNumberError}),
      value: changeNum(phoneNumber),
      error: phoneNumberError,
      errorMessage: 'Please ensure a 10-digit phone number is entered.',
    },
    {
      label: 'Email',
      id: 'email',
      onChange: handleEmailChange({setEmail, setEmailError}),
      value: email,
      error: emailError,
      errorMessage: 'Ensure a valid email format ex. ‘username@domain.com’.',
    },
  ];

  return fields;
}

export function getHandleFocusHandler({
  setPhoneNumberError,
  setEmailError,
}: any) {
  return () => {
    setPhoneNumberError(false);
    setEmailError(false);
  };
}
